import { OpportunitiesPanelsCommentsModel } from "../../../../Models/OpportunitiesPanelsModel";
import './styles.css';
import EditCommentsPanelsComponent from "../EditCommentsPanelsComponent";

interface OpportunitiesPanelsCommentsModelProps {
  panelComments: OpportunitiesPanelsCommentsModel[];
  deleteComments: (commentId: string) => Promise<void>;
  editComment: (commentId: string, comment: string) => Promise<void>;
  isAsc: boolean;
}

const filterComments = (comments: OpportunitiesPanelsCommentsModel[]) => {
  return comments.filter(comment => comment.result !== 2);
};

const CommentsPanelsComponent = (props: OpportunitiesPanelsCommentsModelProps) => {
  const filteredComments = filterComments(props.panelComments);
  const filteredLength = filteredComments.length;

  return (
    <div className="scroll" style={{ padding: "0px 10px 0px 0px" }}>
      {filteredComments.map((comment, index) => (
        <EditCommentsPanelsComponent
          panelComments={comment}
          index={index}
          length={filteredLength}
          deleteComments={props.deleteComments}
          editComment={props.editComment}
          key={index}
          isAsc={props.isAsc}
        />
      ))}
    </div>
  );
};

export default CommentsPanelsComponent;